import React from 'react'
import Marquee from "react-fast-marquee";
import partner1 from "./partner-1.png"
import partner2 from "./partner-2.png"
import partner3 from "./partner-3.png"
import partner4 from "./partner-4.png"
import partner5 from "./partner-5.png"
import partner6 from "./partner-6.png"

const partners = [
    { href: "https://irtc.ca", src: partner1, alt: "Interlake Reserves Tribal Council" },
    { href: "https://irtc.ca/lake-st-martin-first-nation", src: partner2, alt: "Lake St. Martin First Nation" },
    { href: "https://irtc.ca/lake-manitoba-first-nation", src: partner3, alt: "Lake Manitoba First Nation" },
    { href: "https://aactivecoin.com", src: partner4, alt: "AActive Pool League" },
    { href: "https://www.facebook.com/p/SONIX-BAR-GRILL-100063455565364/", src: partner6, alt: "Sonix Bar & Grill" },
    { href: "https://twentyplussix.com", src: partner5, alt: "Twenty Plus Six Web Development" },
]

const Footer = () => {
    return (
        <footer className="main-footer">
            <div className="partner-strip">
                <Marquee speed={40} gradient={false} pauseOnHover>
                    {partners.concat(partners).map((partner, index) => (
                        <a
                            key={`${partner.href}-${index}`}
                            href={partner.href}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={partner.src} alt={partner.alt} />
                        </a>
                    ))}
                </Marquee>
            </div>
        </footer>
    )
}

export default Footer
